/* @ngInject */
const icons = () => {
  const self = {}

  self.username = 'account_circle'
  self.password = 'vpn_key'
  self.passwordConfirmation = 'vpn_key'
  self.admin = 'perm_identity'

  return self
}

export default icons



// WEBPACK FOOTER //
// ./public/javascript/sygem/account/resources/icons.resource.js